import { render, staticRenderFns } from "./s4-3.vue?vue&type=template&id=cf993714&scoped=true&"
import script from "./s4-3.vue?vue&type=script&lang=js&"
export * from "./s4-3.vue?vue&type=script&lang=js&"
import style0 from "./s4-3.vue?vue&type=style&index=0&id=cf993714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf993714",
  null
  
)

export default component.exports